export const MARKET_LINKS = {
  vn: "https://record.brave158.com/_tPooiRtU8B7oKQ0offjfsWNd7ZgqdRLk/1/",
  th: "https://record.cole5555.com/_tPooiRtU8B4Sj4LQ_MWLf2Nd7ZgqdRLk/1/",
  my: "https://record.sun988info.com/_tPooiRtU8B4cs37PgC2oAmNd7ZgqdRLk/1/",
};

export const DEFAULT_LINK = "https://affm5688.com/_tPooiRtU8B6gQBcWp-6O8GNd7ZgqdRLk/1/";
export const DEFAULT_MARKET = "default";
export const MARKET_STORAGE_KEY = "app_market";
export const MARKET_DEFAULT_LANG = { vn: "vi", th: "th", my: "ms" };

export function marketFromUrl() {
  try {
    const v = new URLSearchParams(window.location.search).get("market");
    const key = v ? v.toLowerCase() : null;
    return key && MARKET_LINKS[key] ? key : null;
  } catch (e) {
    return null;
  }
}

export function marketFromStorage() {
  try {
    const v = localStorage.getItem(MARKET_STORAGE_KEY);
    return v && MARKET_LINKS[v] ? v : null;
  } catch (e) {
    return null;
  }
}

export function countryToMarket(country) {
  switch ((country || "").toUpperCase()) {
    case "VN":
      return "vn";
    case "TH":
      return "th";
    case "MY":
      return "my";
    default:
      return null;
  }
}

export function marketToLink(market) {
  return MARKET_LINKS[market] || DEFAULT_LINK;
}
